export const DEFAULT_WORKING_HOURS_PER_DAY = 8;
export const DEFAULT_WORKING_DAYS_PER_WEEK = 5;
export const DEFAULT_TIME_FORMAT = 'pretty';
export const DEFAULT_TIME_UNIT = 'minute';
